import { AI_ANALYTICS_PATH, ASK_OUTCOMES, ASK_PHASES } from '../../../constants/aiAnalytics';
import {
  scBlue10,
  scBlue100,
  scDarkBlue100,
  scGray5,
  scGray10,
  scGray15,
  scGray85,
  scPurple20,
  scPurple80,
  scPurple100,
  scRed10,
  scRed100,
  scWhite,
  scYellow100
} from '../../../constants/systemColors';

export const SEMANTIC_MODEL_PATH = `${AI_ANALYTICS_PATH}/semantic`;

export const AI_COLORS = {
  brand: scPurple80,
  brandDark: scPurple100,
  brandSurface: scPurple20,
  primary: scBlue100,
  primaryDark: scDarkBlue100,
  primarySurface: scBlue10,
  accent: scYellow100,
  surfaceMuted: scGray5,
  errorSurface: scRed10,
  errorText: scRed100,
  codeSurface: scGray85,
  codeText: scGray10,
  codeSurfaceLight: scGray10,
  border: scGray15,
  onBrand: scWhite
};

export const CHAT_CHART_HEIGHT = 360;
export const SAVED_CHART_HEIGHT = 380;
export const RESULT_TABLE_MAX_HEIGHT = 400;
export const RESULT_TABLE_ROWS_PER_PAGE = 25;
export const RESULT_TABLE_ROWS_PER_PAGE_OPTIONS = [25, 50, 100, 250];
export const MAX_FILTER_VALUES = 50;
export const FILTERS_DRAWER_WIDTH = 400;
export const POINTER_INPUT_SX = {
  '& .MuiInputBase-root': { cursor: 'pointer' },
  '& .MuiInputBase-root input': { cursor: 'pointer' },
  '& .MuiAutocomplete-inputRoot': { cursor: 'pointer' }
};
export const MIN_CATEGORY_WIDTH = 44;
export const MIN_CATEGORY_HEIGHT = 28;
export const CHART_PADDING_ALLOWANCE = 96;

export const PHASE_LABELS = {
  [ASK_PHASES.PENDING]: 'Queued — waiting for an available worker…',
  [ASK_PHASES.REASONING]: 'Planning your query…',
  [ASK_PHASES.GENERATING]: 'Generating SQL…',
  [ASK_PHASES.VALIDATING]: 'Validating the query…',
  [ASK_PHASES.EXECUTING]: 'Running the query against the warehouse…',
  [ASK_PHASES.FINISHED]: 'Preparing results…'
};

export const ASK_PHASE_PROGRESS = {
  [ASK_PHASES.PENDING]: 10,
  [ASK_PHASES.REASONING]: 30,
  [ASK_PHASES.GENERATING]: 50,
  [ASK_PHASES.VALIDATING]: 70,
  [ASK_PHASES.EXECUTING]: 90,
  [ASK_PHASES.FINISHED]: 98
};

export const ASK_OUTCOME_LABELS = {
  [ASK_OUTCOMES.FINISHED]: 'Done — the results are ready in the thread.',
  [ASK_OUTCOMES.REFUSED]: 'Finished — see the thread for details.',
  [ASK_OUTCOMES.FAILED]: 'Failed — open the thread for details.'
};
